const navigation = (function(){
	/** Private **/
	const menue = document.querySelector('nav.main-nav ul');
	const menueButton = document.querySelector('nav.main-nav span.toggle-menue');

	function toggleMenue(event){
		menue.classList.toggle('active');
	}

	/** Public **/
	function setup(){
		menueButton.addEventListener('click',toggleMenue);
	}

	return setup;
})();